import {useEffect} from 'react'
import {Outlet} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {setLanguage, useLang} from '../../../_metronic/i18n/Metronici18n'
import {authPublicLinks} from './authLinks'

const AuthLayout = () => {
  const {formatMessage} = useIntl()
  const lang = useLang()
  const links = authPublicLinks(lang)
  const nextLanguage = lang === 'ar' ? 'en' : 'ar'

  useEffect(() => {
    const root = document.getElementById('root')
    if (root) {
      root.style.height = '100%'
    }
    return () => {
      if (root) {
        root.style.height = 'auto'
      }
    }
  }, [])

  return (
    <div className='d-flex flex-column flex-lg-row flex-column-fluid h-100'>
      {/* begin::Body */}
      <div className='d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1'>
        <div className='d-flex justify-content-end px-5'>
          <button
            type='button'
            className='btn btn-sm btn-light-primary border border-primary border-opacity-25 rounded-pill d-inline-flex align-items-center gap-2 px-4 py-2 fw-semibold shadow-sm'
            onClick={() => setLanguage(nextLanguage)}
            aria-label={lang === 'ar' ? 'Switch to English' : 'التبديل إلى العربية'}
          >
            <i className='fas fa-globe fs-5' aria-hidden='true' />
            <span>{lang === 'ar' ? 'English' : 'العربية'}</span>
          </button>
        </div>

        {/* begin::Form */}
        <div className='d-flex flex-center flex-column flex-lg-row-fluid'>
          {/* begin::Wrapper */}
          <div className='w-lg-500px p-10'>
            <Outlet />
          </div>
          {/* end::Wrapper */}
        </div>
        {/* end::Form */}

        {/* begin::Footer */}
        <div className='d-flex flex-center flex-wrap px-5'>
          {/* begin::Links */}
          <div className='d-flex flex-wrap justify-content-center gap-5 fw-semibold text-primary fs-base'>
            <a href={links.terms} target='_blank' rel='noreferrer'>
              {formatMessage({id: 'AUTH.FOOTER.TERMS'})}
            </a>

            <a href={links.plans} target='_blank' rel='noreferrer'>
              {formatMessage({id: 'AUTH.FOOTER.PLANS'})}
            </a>

            <a href={links.contact} target='_blank' rel='noreferrer'>
              {formatMessage({id: 'AUTH.FOOTER.CONTACT'})}
            </a>
          </div>
          {/* end::Links */}
        </div>
        {/* end::Footer */}
      </div>
      {/* end::Body */}
    </div>
  )
}

export {AuthLayout}
